import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React, { useEffect, useState } from 'react'
import { WEBSITE_URL } from '../../../env'
import { Dialogs, useDialogs } from '../../../sharedComponents/src/Contexts/DialogsContext'
import { useGlobalContext } from '../../../sharedComponents/src/Contexts/GlobalContext'
import HintWithText from '../../../sharedComponents/src/DailyBonus/Common/HintWithText'
import AnimatedDialog from '../../../sharedComponents/src/Dialogs/Common/AnimatedDialog'
import SignUp from '../../../sharedComponents/src/Dialogs/Forms/SignUp'
import { GroupNames } from '../../../sharedComponents/src/globalHeader/GlobalHeader'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreState } from '../../../store/hooks'

const HintLimitDialog: React.FC = () => {
    const { userType } = useGlobalContext()
    const { isMobile } = useScreenSize()
    const { registerDialog, unregisterDialog } = useDialogs()
    const initialHintAmounts = useStoreState((state) => state.dailyBonus.initialHintAmounts)
    const [amount, setAmount] = useState(0)

    useEffect(() => {
        const initialAmountKey = initialHintAmounts.findIndex((item) => item.userType === userType)
        const nextInitialAmount = initialHintAmounts[initialAmountKey + 1]
        setAmount(nextInitialAmount?.amount || 0)
    }, [initialHintAmounts, userType])

    const onClickHandler = () => {
        if (userType === GroupNames.MEMBER) {
            window.location.href = `${WEBSITE_URL}/memberships`
        } else {
            unregisterDialog(Dialogs.HINT_LIMIT)
            registerDialog(Dialogs.SIGNUP, <SignUp />)
        }
    }

    return (
        <AnimatedDialog
            name={Dialogs.HINT_LIMIT}
            borderColor="primary.main"
            paperProps={{
                animationOrImage: {
                    src: `/assets/images/${userType === GroupNames.MEMBER ? 'hint-subscribe.svg' : 'hint-signup.svg'}`,
                    verticalPosition: {
                        xs: '-35px',
                        md: '-60px',
                    },
                    horizontalPosition: {
                        xs: '39%',
                        md: userType === GroupNames.MEMBER ? '41%' : '42%',
                    },
                },
            }}
        >
            <Stack
                gap={isMobile ? 2 : 4}
                alignItems="center"
                sx={{ pt: userType === GroupNames.MEMBER ? 3 : isMobile ? 5 : 3 }}
            >
                {/* Title */}
                <Typography variant={isMobile ? 'h5' : 'h2'} textTransform="uppercase">
                    {userType === GroupNames.MEMBER ? 'Subscribe now' : 'Create a free account'}
                </Typography>

                {/* Content */}
                <HintWithText amount={amount} />

                {/* Actions */}
                <Button variant="contained" size={isMobile ? 'medium' : 'large'} onClick={onClickHandler}>
                    {userType === GroupNames.MEMBER ? 'Go Premium' : 'Join free now'}
                </Button>
            </Stack>
        </AnimatedDialog>
    )
}

export default HintLimitDialog
